import { render, staticRenderFns } from "./AdminUsersElement.vue?vue&type=template&id=32d71c12&scoped=true"
import script from "./AdminUsersElement.vue?vue&type=script&lang=js"
export * from "./AdminUsersElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersElement.vue?vue&type=style&index=0&id=32d71c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d71c12",
  null
  
)

export default component.exports